const FILES_BASE_URL = import.meta.env.VITE_FILES_BASE_URL || 'https://www.cabaza.be/files';

/**
 * La galerie de captures d'écran.
 *
 * Les chemins passent par VITE_FILES_BASE_URL, jamais par une URL codée en
 * dur : l'adresse du stockage diffère entre développement et production.
 *
 * `alt` est traduit, `image` ne l'est pas — c'est un chemin de fichier.
 * Une capture sans description reste accessible : alt="" la déclare
 * décorative plutôt que de laisser un lecteur d'écran lire un nom de
 * fichier.
 */
const CapturesBloc = ({ bloc }) => {
    const captures = Array.isArray(bloc?.captures) ? bloc.captures : [];
    const visibles = captures.filter(c => c?.image);
    if (visibles.length === 0) return null;

    return (
        <section className="mb-10" data-testid="bloc-captures">
            {bloc.titre && (
                <h2 className="text-xl font-bold text-gray-900 mb-5">{bloc.titre}</h2>
            )}
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {visibles.map((c, i) => (
                    <figure key={i}>
                        <img
                            src={`${FILES_BASE_URL}/${c.image}`}
                            alt={c.alt || ''}
                            loading="lazy"
                            className="w-full rounded-xl border border-gray-200 object-cover"
                        />
                        {c.legende && (
                            <figcaption className="mt-2 text-xs text-gray-500 text-center">
                                {c.legende}
                            </figcaption>
                        )}
                    </figure>
                ))}
            </div>
        </section>
    );
};

export default CapturesBloc;
